"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var localstorage_1 = require("./localstorage");
var ENV = typeof window !== 'undefined' ? window : (typeof global !== 'undefined' ? global : undefined);
var localstorage = new localstorage_1.LocalStorage(ENV);
if (process.env.NODE_ENV !== 'production') {
    if (!localstorage.supported) {
        console.warn("You environment doesn't support localStorage");
    }
}
__export(require("./localstorage"));
__export(require("./env"));
exports.default = localstorage;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSwrQ0FBNkM7QUFFN0MsSUFBTSxHQUFHLEdBQUcsT0FBTyxNQUFNLEtBQUssV0FBVyxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFDLENBQ25ELE9BQU8sTUFBTSxLQUFLLFdBQVcsQ0FBQyxDQUFDLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxTQUFTLENBQzdCLENBQUE7QUFFdkIsSUFBTSxZQUFZLEdBQUcsSUFBSSwyQkFBWSxDQUFDLEdBQUcsQ0FBQyxDQUFBO0FBRTFDLElBQUksT0FBTyxDQUFDLEdBQUcsQ0FBQyxRQUFRLEtBQUssWUFBWSxFQUFFO0lBQ3pDLElBQUksQ0FBQyxZQUFZLENBQUMsU0FBUyxFQUFFO1FBQzNCLE9BQU8sQ0FBQyxJQUFJLENBQUMsOENBQThDLENBQUMsQ0FBQTtLQUM3RDtDQUNGO0FBRUQsb0NBQThCO0FBQzlCLDJCQUFxQjtBQUVyQixrQkFBZSxZQUFZLENBQUEifQ==